var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriaPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 706,
    height: 385,
    viewBox: "0 0 706 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4089_5929)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 352.647,
    cy: 192.549,
    rx: 260.5,
    ry: 92.5,
    transform: "rotate(-7.80374 352.647 192.549)",
    fill: "url(#paint0_linear_4089_5929)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4089_5929",
    x: 0.248047,
    y: 0.290039,
    width: 704.797,
    height: 384.518,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 47,
    result: "effect1_foregroundBlur_4089_5929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4089_5929",
    x1: 364.65,
    y1: 106.766,
    x2: 507.851,
    y2: 273.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8568F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825488,
    stopColor: "#4440D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriaPurple);
export default __webpack_public_path__ + "static/media/tria-purple.b688ce4a217f6523c643f55069be90f0.svg";
export { ForwardRef as ReactComponent };